/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { AuthActions, AuthLogoutAction } from '../auth/types';
import { ResourcesActions, ResourcesActionTypes, ResourcesState } from './types';

export const initialResourcesState: ResourcesState = {
  thumbnailsVersion: Date.now(),
};

export function resources(state = initialResourcesState, action: ResourcesActionTypes | AuthLogoutAction) {
  switch (action.type) {
    case ResourcesActions.SET_THUMBNAILS_VERSION:
      return {
        ...state,
        thumbnailsVersion: action.payload.thumbnailsVersion,
      };
    case AuthActions.AUTH_LOGOUT:
      return {
        ...state,
        thumbnailsVersion: Date.now(),
      };
    default:
      return state;
  }
}
